export default __webpack_public_path__ + "static/media/PAFI_Annual Report 2023.c0e68e7a.pdf";